export default "__VITE_ASSET__cf77397e__"